import graphqlClient from '@/graphql/graphql-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  UpdateContactsDocument,
  type UpdateContactsMutationVariables,
} from '@/graphql/generated/graphql';

export type ContactUpdateInput = {
  ItemId: string;
} & Omit<UpdateContactsMutationVariables, 'itemId'>;

export const useUpdateContact = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationKey: ['update-contact'],
    mutationFn: ({ ItemId, ...fields }: ContactUpdateInput) =>
      graphqlClient.request(UpdateContactsDocument, { itemId: ItemId, ...fields }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['contacts'] });
    },
  });

  return {
    ...mutation,
    updateContact: mutation.mutate,
    updateContactAsync: mutation.mutateAsync,
  };
};

export default useUpdateContact;
